import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiurbaniaonrent() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Urbania on Rent',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Urbania on Rent',
    headingDescription: 'Force Urbania on rent in Pune with Sai Trupti Cabs offers a flawless travel experience for large groups and out-station trips, especially routes like Pune to Mumbai. Our fleet comprises well-maintained, spacious Urbania vans (available in 9-16+1 seating options) with full air-conditioning, ample luggage space, and comfortable interiors ideal for group travel. Each trip is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Mumbai. With transparent per-km or day-package pricing, flexible booking options (one-way, round-trip, local hour-packages, or out-station routes), and 24 × 7 customer support, Sai Trupti Cabs makes your Urbania hire from Pune for the Pune→Mumbai route convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, perched at Apollo Bunder and overlooking the Arabian Sea. Built in 1924 to mark the arrival of King George V and Queen Mary, the grand arch blends Indo-Saracenic architecture with colonial elegance. Tourists arrive by ferry to the nearby island, and many pause here to savour street vendors, sea-breeze, and the timeless view of boats on the water. As dusk falls, the monument glows under lights and the surrounding crowd hums with life. With the nearby Taj Mahal Palace hotel and the city skyline close by, the Gateway symbolises Mumbai’s heritage, welcoming spirit and sea-facing grandeur."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is a 3.6 km sweeping boulevard that curls alongside the Arabian Sea and has earned the nickname ‘Queen’s Necklace’ for the strand of lights that gleams like pearls at night. At sunset, locals and tourists gather along the promenade to feel the sea-breeze, watch joggers, or simply sit on the railings and reflect. The art-deco buildings on the opposite side echo an era of architectural elegance. With the waves gently lapping below, and the city’s lights coming alive above, Marine Drive embodies Mumbai’s dual rhythm — calming sea and buzzing metropolis. It’s the perfect place for a scenic drive, a leisure walk or a moment of quiet in the city roar."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of Mumbai’s greatest architectural masterpieces. Completed in 1887, the station blends Victorian-Gothic design and Indian motifs: domes, stained glass, arches, carved stone animals, and grand facades. It remains one of India’s busiest railway hubs, yet every passing train seems to echo centuries of the city’s progress. Standing on the polished stone floor, you feel the rhythm of millions of commuters and the grandeur of a bygone era. CSMT is not just transport — it’s a living monument in Mumbai’s heart."
  },
  {
    "title": "Elephanta Caves",
    "description": "Accessible by a short ferry ride from the Gateway of India, the Elephanta Caves lie on Elephanta Island and are a remarkable heritage destination dating back to the 5th-7th centuries. Carved into basalt rock and dedicated to Lord Shiva, the most renowned sculpture is the three-headed Trimurti symbolising creation, preservation and destruction. Visitors wander through dark chambers, climb steep steps, and emerge to stunning sea views across the island. The journey from Mumbai’s bustle to the island’s quiet hills feels like a time-travel into spirituality and stone-art. Elephanta invites you to slow down, look up and reflect on ancient artistry."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach stretches along Mumbai’s western suburbs and is one of its most loved seaside escapes. As the sun begins to set, families, couples and street-food lovers converge on the sands, enjoying pav-bhaji, bhel puri, golas and the cool sea-breeze. The sounds of waves, laughter, vendors and even planes (arriving at nearby airport) mix into a uniquely Mumbai vibe. With the iconic Bollywood homes nearby and the wide open horizon beyond, Juhu offers a slice of coastal freedom in the city. Whether it’s a morning jog, an evening stroll or a kite in the sky, Juhu Beach is where urban pace and sea calm meet."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah sits majestically on a small islet off Worli, connected to the mainland by a narrow causeway that disappears at high tide — creating a magical impression of the mosque floating on the sea. Built in the 15th century, the white marble shrine honours the Sufi saint Pir Haji Ali Shah Bukhari and draws devotees from many faiths. The rhythmic sound of waves, scent of incense, and call to prayer blend into a spiritual aura that transcends the city’s hustle. A simple walk along the causeway, set against sea-spray and sky, offers one of Mumbai’s most peaceful moments."
  },
  {
    "title": "Colaba Causeway & South Mumbai Heritage",
    "description": "Colaba Causeway is one of Mumbai’s most vibrant shopping and cultural streets, located in the heritage zone of South Mumbai. From fashion stalls, antiques, leather goods and souvenirs to famed cafés like Leopold and Café Mondegar, the area pulses with colour and conversation. Beneath its modern buzz lies colonial-era architecture, narrow alleys, and the legacy of a city shaped by trade and sea. Walking the Causeway at twilight, sipping coffee, browsing goods and absorbing the street-life, you sense the cosmopolitan heart of Mumbai — inclusive, historic, creative."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a modern engineering marvel spanning the Arabian Sea and linking South Mumbai to the western suburbs. This cable-stayed bridge seems to float above the water at dusk as its lights trace a silver arc across the bay. Driving across it reveals breathtaking skyline views, the sea shimmering below and twin worlds of old and new Mumbai. More than a piece of infrastructure, the Sea Link symbolises the city’s ambition and progress — the connection of tradition and tomorrow."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park, located within the city’s northern reaches, is a green sanctuary of forest, wildlife and ancient rock-cut caves (Kanheri Caves). The vast reserve offers hiking trails, lush hills, boating, and a contrast to Mumbai’s concrete core. As you walk beneath trees, spotting monkeys and birds, you’re reminded that nature still thrives in the metropolis. The Kanheri caves, carved centuries ago, add archaeology and spirituality to the park. Together they create a refreshing retreat from urban rush and a hidden side of Mumbai many overlook."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual sites, dedicated to Lord Ganesha and visited by thousands each day. Built in 1801, it radiates faith, hope and devotion amid the city’s frenetic pace. The golden dome, the carved Ganesha idol, the queue of pilgrims, and the ringing bells create an immersive aura of sincerity. Visitors from all walks of life — families, celebrities, travellers — come seeking blessings, making Siddhivinayak a beacon of inner calm in bustling Mumbai."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Urbania on Rent",
    "description": "Rent an Urbania from Pune to Mumbai with spacious seating, AC/non-AC options, professional drivers, luggage assistance, and flexible schedules. Ideal for family trips, group travel, corporate travel, and leisure outings, offering a comfortable, safe, and timely journey with transparent fares and online booking options."
  },
  {
    "name": "Pune to Mumbai Urbania Hire",
    "description": "Reliable Urbania hire service from Pune to Mumbai providing well-maintained vehicles, professional drivers, luggage support, AC/non-AC options, and flexible pickup/drop points. Perfect for long-distance travel, family outings, and group trips, ensuring comfort, safety, and convenience throughout the journey."
  },
  {
    "name": "Pune to Mumbai Force Urbania 14 Seater",
    "description": "Spacious 14-seater Force Urbania from Pune to Mumbai with AC/non-AC options, professional drivers, luggage assistance, and flexible schedules. Ideal for medium-sized groups, corporate teams, or family trips, offering a comfortable and safe journey with transparent fares and reliable service."
  },
  {
    "name": "Pune to Mumbai Force Urbania 16 Seater",
    "description": "16-seater Force Urbania rental from Pune to Mumbai with AC/non-AC options, luggage support, professional drivers, and flexible pickup/drop points. Suitable for large families, corporate groups, and group tours, ensuring a comfortable and hassle-free long-distance travel experience."
  },
  {
    "name": "Pune to Mumbai Force Urbania 17 Seater",
    "description": "17-seater Force Urbania service from Pune to Mumbai with AC/non-AC options, professional drivers, luggage assistance, and flexible scheduling. Ideal for extended group travel, family vacations, and corporate trips, providing spacious seating, comfort, and safe transportation with clear and transparent fares."
  },
  {
    "name": "Pune to Mumbai AC Urbania",
    "description": "Comfortable AC Urbania from Pune to Mumbai with professional drivers, luggage support, and flexible pickup/drop points. Perfect for long-distance travel, family outings, and group trips, ensuring a cool and relaxing ride with punctual arrivals and a safe, hassle-free journey."
  },
  {
    "name": "Pune to Mumbai Non AC Urbania",
    "description": "Economical non-AC Urbania service from Pune to Mumbai offering professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares. Ideal for budget-conscious travelers who want a safe and comfortable journey without compromising on convenience."
  },
  {
    "name": "Pune to Mumbai Luxury Urbania",
    "description": "Premium luxury Urbania service from Pune to Mumbai with AC, top-class interiors, professional chauffeurs, luggage assistance, and timely pickups. Perfect for weddings, VIP travel, corporate trips, or special occasions, providing a stylish, comfortable, and reliable travel experience."
  },
  {
    "name": "Affordable Pune to Mumbai Urbania",
    "description": "Budget-friendly Urbania service from Pune to Mumbai with AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and transparent fares. Suitable for families, friends, and groups seeking safe and reliable transportation without exceeding their travel budget."
  },
  {
    "name": "Pune to Mumbai Urbania One Way",
    "description": "Convenient one-way Urbania service from Pune to Mumbai with AC/non-AC options, professional drivers, luggage support, and transparent fares. Ideal for travelers needing a one-way drop without worrying about return trips, providing flexible, safe, and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Urbania Outstation",
    "description": "Outstation Urbania service from Pune to Mumbai with AC/non-AC options, professional drivers, luggage assistance, and flexible schedules. Perfect for long-distance travel, family vacations, and group tours, offering comfort, safety, and timely arrivals with easy online booking."
  },
  {
    "name": "Pune to Mumbai Corporate Urbania",
    "description": "Corporate Urbania service from Pune to Mumbai providing AC/non-AC vehicles, professional drivers, luggage support, and flexible pickup/drop points. Ideal for business trips, client visits, corporate tours, and group travel, ensuring punctuality, safety, and a professional travel experience."
  },
  {
    "name": "Pune to Mumbai Wedding Urbania",
    "description": "Wedding Urbania service from Pune to Mumbai with luxurious interiors, AC/non-AC options, professional drivers, luggage support, and timely pickups. Perfect for weddings, transporting guests, family, or VIPs, offering a stylish, comfortable, and safe journey with transparent fares."
  },
  {
    "name": "Online Urbania Booking Pune",
    "description": "Book your Pune to Mumbai Urbania online instantly with secure payments, multiple AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or on short notice, ensuring a hassle-free, transparent, and comfortable travel experience."
  },
  {
    "name": "Best Urbania Service Pune to Mumbai",
    "description": "Top-rated Urbania service from Pune to Mumbai providing well-maintained vehicles, professional drivers, luggage assistance, AC/non-AC options, flexible schedules, and transparent fares. Perfect for families, groups, corporate clients, and leisure travelers seeking a safe, reliable, and comfortable journey."
  }
],
"tableData": [
  ["Pune to Mumbai Urbania on Rent", "Pune to Mumbai Urbania Hire"],
  ["Pune to Mumbai Force Urbania 14 Seater", "Pune to Mumbai Force Urbania 16 Seater"],
  ["Pune to Mumbai Force Urbania 17 Seater", "Pune to Mumbai AC Urbania"],
  ["Pune to Mumbai Non AC Urbania", "Pune to Mumbai Luxury Urbania"],
  ["Affordable Pune to Mumbai Urbania", "Pune to Mumbai Urbania One Way"],
  ["Pune to Mumbai Urbania Outstation", "Pune to Mumbai Corporate Urbania"],
  ["Pune to Mumbai Wedding Urbania", "Online Urbania Booking Pune"],
  ["Best Urbania Service Pune to Mumbai", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Urbania Car Rental",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable Urbania car rental services from Pune to Mumbai — ideal for city travel, airport transfers, or leisure trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Mumbai Urbania rentals, starting at affordable rates depending on the rental duration and service inclusions — no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hire Urbania on an hourly, daily, or multi-day basis to suit your travel schedule and requirements for the Pune to Mumbai route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers ensure a safe, smooth, and timely journey between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Pickup & Drop Flexibility",
    "WhyChoosedescription": "We offer convenient pickups from any location in Pune and drop-offs at your desired destination in Mumbai, including airports, hotels, or city centers."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All Urbania cars are regularly serviced, sanitized, and maintained to provide a comfortable and reliable travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai Urbania cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]



















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai Urbania on rent services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Mumbai Urbania rental services for one-way trips, round trips, and group travel.',
  },
  {
    question: 'How can I book a Pune to Mumbai Urbania on rent with Sai Trupti Cabs?',
    answer: 'You can easily book an Urbania from Pune to Mumbai through our website, mobile app, or by contacting our 24×7 customer support team for quick confirmation.',
  },
  {
    question: 'What types of vehicles are available for Pune to Mumbai Urbania rental?',
    answer: 'We offer Urbania vehicles suitable for 17-seater group travel, along with other options like sedans, SUVs, and tempo travellers to match your group size and travel needs.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Urbania trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel on the Pune–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire an Urbania from Pune to Mumbai for corporate or group travel?',
    answer: 'Certainly. Our Urbania rental services cater to corporate trips, family outings, group tours, and special events between Pune and Mumbai.',
  },
  {
    question: 'Is the Pune to Mumbai Urbania rental service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Urbania rental services from Pune to Mumbai for flexible travel plans and scheduling convenience.',
  },
  {
    question: 'What are the Pune to Mumbai Urbania rental fares?',
    answer: 'Our Pune to Mumbai Urbania rental fares start from approximately ₹3,500–₹5,000 depending on the trip type, distance, and duration.',
  },
  {
    question: 'What payment methods are accepted for Pune to Mumbai Urbania rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free payments.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Urbania rentals from Pune to Mumbai?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during Pune to Mumbai Urbania trips?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai Urbania rental journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Hiring an Urbania from Pune to Mumbai with Sai Trupti Cabs was seamless. The vehicle was comfortable, and the driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patwardhan',
    feedback: 'Excellent Pune to Mumbai Urbania rental service by Sai Trupti Cabs. The trip was smooth, and the driver was very courteous.',
    rating: 5,
  },
];
























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania on Rent",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-urbania.jpg",
  "description": "Hire Urbania from Pune to Mumbai for comfortable travel. Choose from 14/16/17 seater Urbania, AC or Non-AC, luxury options for one-way trips, outstation travel, corporate trips, weddings, or family outings. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-urbania-on-rent"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Urbania on Rent | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Hire Urbania from Pune to Mumbai for comfortable travel. Choose from 14/16/17 seater Urbania, AC or Non-AC, luxury options for one-way trips, outstation travel, corporate trips, weddings, or family outings. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Urbania on Rent, Pune to Mumbai Urbania Hire, Pune to Mumbai Force Urbania 14 Seater, Pune to Mumbai Force Urbania 16 Seater, Pune to Mumbai Force Urbania 17 Seater, Pune to Mumbai AC Urbania, Pune to Mumbai Non AC Urbania, Pune to Mumbai Luxury Urbania, Affordable Pune to Mumbai Urbania, Pune to Mumbai Urbania One Way, Pune to Mumbai Urbania Outstation, Pune to Mumbai Corporate Urbania, Pune to Mumbai Wedding Urbania, Online Urbania Booking Pune, Best Urbania Service Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiurbaniaonrent;